// extracted by mini-css-extract-plugin
module.exports = {"body":"_3morFDA","twoColumns":"_EILxRFi","main":"_14RTD8J","side":"_3uXawMA","mainSkeleton":"_3iBXMJA"};